class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (!parsedState || !parsedState.sections) {
      console.error('Cart notification: Invalid parsedState', parsedState);
      // Still try to open even if rendering fails
      this.open();
      return;
    }

    if (parsedState.key) {
      this.cartItemKey = parsedState.key;
    }

    this.getSectionsToRender().forEach((section) => {
      if (!parsedState.sections[section.id]) {
        console.warn(`Cart notification: Section data not found for ${section.id}`);
        return;
      }

      if (section.id === 'cart-icon-bubble') {
        if (typeof window.syncCartIconBubble === 'function') {
          window.syncCartIconBubble(parsedState.sections[section.id]);
        }
        return;
      }

      const sectionElement = document.getElementById(section.id);
      if (!sectionElement) {
        console.warn(`Cart notification: Section element not found for ${section.id}`);
        return;
      }

      try {
        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      } catch (error) {
        console.error(`Cart notification: Error rendering section ${section.id}`, error);
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
